<template lang="pug">
  v-dialog(v-model="show" max-width="500px" persistent scrollable :fullscreen="$vuetify.breakpoint.mdAndDown" )
    v-card(align="center")
      v-card-title {{ $t('smartLinkPage.deleteSmartLinkTitle') }}
      v-row.ma-0.align-self-center(align="center" )
        v-card-text.text-center {{ $t('smartLinkPage.deleteSmartLinkTitle') }} {{this.selectedSmartLink.slug}}
      v-divider
      v-card-actions
        v-spacer
        v-btn.mr-2(@click="onCloseButtonClick" text) {{ $t('sendEmailDialog.no') }}
        v-btn.mr-2(@click="onSubmitButtonClick" color="primary" :loading="confirmDelete") {{ $t('sendEmailDialog.yes') }}



</template>

<script lang="ts">
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import {MessageTemplateList} from "@/model/MessageTemplateList";
import SmartLink from "@/model/SmartLink";

@Component({})

export default class ControlDeleteSmartLinkDialog extends Vue {


  @Prop({ type: Boolean, default: false }) readonly show!: boolean
  @Prop({ type: Object, default: false }) readonly selectedSmartLink!: SmartLink

  private confirmDelete: boolean = false


  onCloseButtonClick (): void {
    this.$emit('close')
  }

  onSubmitButtonClick (): void {
    this.confirmDelete = true
    this.$emit('delete',this.selectedSmartLink)
  }


  mounted () {
  }
}

</script>

<style lang="stylus" scoped>
.card-body
  overflow auto
</style>